import type { SavedLocation } from '@hero/schema';
import { getObjectId } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useOrderListApi } from '@hero/api-hooks';
import { SharedList } from '../../../app/List/List';
import { OrderCard } from '../../Order/Card/OrderCard';

export interface SavedLocationOrdersTabProps {
  savedLocation: SavedLocation;
  displayForUser: 'customer' | 'carrier';
}

export function SavedLocationOrdersTab({
  savedLocation,
  displayForUser,
}: SavedLocationOrdersTabProps) {
  const { t } = useTranslation(['m-location']);

  const ordersQuery = useOrderListApi({
    savedLocationId: getObjectId(savedLocation._id),
  });

  return (
    <div className="flex flex-col gap-3 p-5">
      <SharedList
        query={ordersQuery}
        emptyMessage={t('drawer.no_orders')}
        className="gap-3"
        renderItem={order => (
          <OrderCard order={order} displayForUser={displayForUser} />
        )}
      />
    </div>
  );
}
